import { ref } from "vue"

const showSubModal = ref(false)
const subFeature = ref("")
export { showSubModal, subFeature }
